import { render, staticRenderFns } from "./Extrusions.vue?vue&type=template&id=c23bfcf2"
import script from "./Extrusions.vue?vue&type=script&lang=js"
export * from "./Extrusions.vue?vue&type=script&lang=js"
import style0 from "./Extrusions.vue?vue&type=style&index=0&id=c23bfcf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports